<template>
  <div class="ccui-app-container" style="height: 100vh">
    <div class="ccui-advanced-search-wrapper ccui-clearfix">
      <el-search
        :formProp="searchData"
        @search="searchEvent"
        :isShowSearch="true"
        class="ccui-highsearch"
        :selectClear="true"
      >
        <template slot="search">
          <el-input
            v-model="searchData.reqname"
            clearable
            searchLabel="单位全称"
            placeholder="请输入单位全称精确查询"
          />

          <el-select
            v-model="searchData.type"
            clearable
            searchLabel="类型"
            placeholder="请选择类型"
            class="ccui-form-longInput"
          >
            <el-option key="分包商" label="分包商" value="0"></el-option>
            <el-option key="供应商" label="供应商" value="1"></el-option>
            <el-option key="商家" label="商家" value="2"></el-option>
            <el-option key="采购单位" label="采购单位" value="4"></el-option>
          </el-select>
          <el-select
            v-model="searchData.state"
            clearable
            searchLabel="状态"
            placeholder="请选择状态"
            class="ccui-form-longInput"
          >
            <el-option key="已审核" label="已审核" value="3"></el-option>
            <el-option key="未审核" label="未审核" value="2"></el-option>
            <el-option key="同意" label="同意" value="1"></el-option>
            <el-option key="拒绝" label="拒绝" value="0"></el-option>
          </el-select>
        </template>
        <el-input
          v-model="searchData.reqname"
          clearable
          searchLabel="单位全称 "
          placeholder="请输入单位全称模糊查询"
          slot="searchItem1"
        />
        <el-select
          v-model="searchData.type"
          clearable
          searchLabel="类型"
          placeholder="请选择类型"
          class="ccui-form-longInput"
          slot="searchItem2"
        >
          <el-option key="分包商" label="分包商" value="0"></el-option>
          <el-option key="供应商" label="供应商" value="1"></el-option>
          <el-option key="商家" label="商家" value="2"></el-option>
          <el-option key="采购单位" label="采购单位" value="4"></el-option>
        </el-select>
        <el-select
          v-model="searchData.state"
          clearable
          searchLabel="状态"
          placeholder="请选择状态"
          class="ccui-form-longInput"
          slot="searchItem3"
        >
          <el-option key="已审核" label="已审核" value="3"></el-option>
          <el-option key="未审核" label="未审核" value="2"></el-option>
          <el-option key="同意" label="同意" value="1"></el-option>
          <el-option key="拒绝" label="拒绝" value="0"></el-option>
        </el-select>
      </el-search>
    </div>

    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        border
        class="ccui-multifunctional-table"
      >
        <el-table-column type="index" width="60" label="序号" fixed>
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <template v-for="(table, index) in tableColumnData">
          <el-table-column
            :fixed="table.fixed || false"
            :type="table.type"
            :key="index"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :show-overflow-tooltip="true"
            :align="table.align"
            :header-align="table.headerAlign || 'left'"
          >
            <template slot-scope="scope">
              {{ scope.row[table.prop] }}
            </template>
          </el-table-column>
        </template>
        <!-- 操作 -->
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <!-- <el-button
              v-if="scope.row.fileurl"
              type="text"
              size="small"
              @click="preview(scope.row.fileurl)"
              >预览
            </el-button> -->
            <el-button
              v-if="scope.row.fileurl"
              type="text"
              size="small"
              @click="downLoad(scope.row.fileurl)"
              >下载
            </el-button>
            <el-button
              :disabled="scope.row.stateStr !== '未审核'"
              type="text"
              size="small"
              @click="consentAndrefuse('1', scope.row)"
              >同意
            </el-button>
            <el-button
              :disabled="scope.row.stateStr !== '未审核'"
              type="text"
              size="small"
              @click="consentAndrefuse('0', scope.row)"
              >拒绝</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="ccui-table-footer" style="height: 30px; margin-top: 20px">
      <div id="ccui-paging">
        <el-pagination
          v-if="tableData.length > 0"
          :total="page.total"
          :page-size="page.pageSize"
          :current-page="page.pageNo"
          :page-sizes="[10, 20, 50, 100, 200, 500]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          popper-class="ccui-paging-page-size-popper"
          @prev-click="handlePrev"
          @next-click="handleNext"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import { list, updateApi } from "../api/submit";
export default {
  name: "list",
  props: {},
  data() {
    return {
      loading: false,
      tableData: [],
      searchData: { reqName: "", type: "" },
      searchObj: {},
      page: { total: 0, pageSize: 10, pageNo: 1 },
      tableColumnData: [
        {
          label: "单位全称",
          prop: "reqname",
          width: 260,
          fixed: true
        },
        {
          label: "手机号",
          prop: "reqmobile",
          width: 260
        },
        {
          label: "邮箱",
          prop: "reqemail",
          width: 260
        },
        {
          label: "类型",
          prop: "typeStr",
          width: 260
        },
        {
          label: "状态",
          prop: "stateStr",
          width: 260
        }
      ]
    };
  },
  created() {
    this.getList();
  },
  mounted() {},

  methods: {
    getList() {
      list({
        ...this.page,
        ...this.searchObj,
        agentId: "100001"
      }).then(res => {
        const { rows, recordsTotal } = res.data.data;
        rows.forEach(item => {
          // 3-已审核 2-未审核 1-同意 0-拒绝
          switch (item.state) {
            case 3:
              item.stateStr = "已审核";
              break;
            case 2:
              item.stateStr = "未审核";
              break;

            case 1:
              item.stateStr = "同意";
              break;

            case 0:
              item.stateStr = "拒绝";
              break;
          }
          //0-分包商，1-供应商，2商家，3店铺，4采购单位(默认分包商)
          switch (item.type) {
            case 4:
              item.typeStr = "采购单位";
              break;
            case 3:
              item.typeStr = "店铺";
              break;

            case 2:
              item.typeStr = "商家";
              break;

            case 1:
              item.typeStr = "供应商";
              break;

            case 0:
              item.typeStr = "分包商";
              break;
          }
        });
        this.tableData = rows;
        this.page.total = recordsTotal;
      });
    },
    // 预览
    preview(fileUrl) {
      const previewSrc = this.getPreviewUrl(fileUrl);
      window.open(previewSrc);
    },
    // 预览前处理
    getPreviewUrl(fileUrl) {
      const o = window.location;
      const isProd = o.hostname.split("-").length === 1;
      const perfix = isProd ? "https://" : "http://dev01-";
      const previewSrc = `${perfix}preview.iccec.cn/onlinePreview?url=${encodeURIComponent(
        fileUrl.startsWith("http") ? Base64.encode(fileUrl) : fileUrl
      )}`;
      return previewSrc;
    },
    //下载
    downLoad(url) {
      // window.location.href = url;
      window.open(url);
      // let openUrl = document.createElement("a");
      // openUrl.style.display = "none";
      // openUrl.href = url;
      // openUrl.setAttribute("download",'');
      // document.body.appendChild(openUrl);
      // openUrl.click();
    },
    // 同意/拒绝
    consentAndrefuse(status, row) {
      // status = 1同意  0拒绝
      if (status == "0") {
        this.$confirm("确定拒绝吗？")
          .then(_ => {
            updateApi({ state: status, agentId: "100001", id: row.id }).then(
              res => {
                this.$message.success(res.data.message);
                this.getList();
              }
            );
          })
          .catch(_ => {});
      } else {
        updateApi({ state: status, agentId: "100001", id: row.id }).then(
          res => {
            this.$message.success(res.data.message);
            this.getList();
          }
        );
      }
    },
    // 搜索
    searchEvent(obj) {
      this.searchObj = obj;
      this.page.pageNo = 1;
      this.getList();
    },
    // 上一页
    handlePrev(val) {
      this.page.pageNo = val;
      this.getList();
    },
    // 下一页
    handleNext(val) {
      this.page.pageNo = val;
      this.getList();
    },
    // 展示条数
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    // 页码点击事件
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getList();
    }
  },
  filter: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped></style>
